import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_SERVICE = "GET_LIST_SERVICE";
export const GET_DETAIL_SERVICE = "GET_DETAIL_SERVICE";
export const UPDATE_SERVICE = "UPDATE_SERVICE";
export const SAVE_SERVICE = "SAVE_SERVICE";
export const DELETE_SERVICE = "DELETE_SERVICE";
export const SET_LIST_SERVICE = "SET_LIST_SERVICE";
export const SET_DETAIL_SERVICE = "SET_DETAIL_SERVICE";



const state = {
    service: [],
    serviceDetail: {}
};

const getters = {
    service(state) {
        return state.service;
    },
    serviceDetail(state) {
        return state.serviceDetail;
    },


};

const actions = {
    [GET_LIST_SERVICE](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_SERVICE}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_SERVICE, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_SERVICE](context,id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_SERVICE}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_SERVICE, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_SERVICE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_SERVICE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_SERVICE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_SERVICE}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_SERVICE](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_SERVICE}`,id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};

const mutations = {
    [SET_LIST_SERVICE](state, data) {
        state.service = data.data;
    },
    [SET_DETAIL_SERVICE](state, data) {
        state.serviceDetail = data.data;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};